import React from "react";

import { Skeleton as MuiSkeleton, Stack } from "@components/base";

const Skeleton: React.FC = () => {
  return (
    <Stack gap={2}>
      <Stack direction="row" gap={1}>
        <MuiSkeleton variant="rectangular" width={40} height={40} />
        <MuiSkeleton variant="rectangular" width="100%" height={40} />
        <MuiSkeleton variant="rectangular" width={200} height={40} />
      </Stack>
      <Stack direction="row" gap={1}>
        <MuiSkeleton variant="rectangular" width={40} height={40} />
        <MuiSkeleton variant="rectangular" width="100%" height={40} />
        <MuiSkeleton variant="rectangular" width={200} height={40} />
      </Stack>
      <Stack direction="row" gap={1}>
        <MuiSkeleton variant="rectangular" width={40} height={40} />
        <MuiSkeleton variant="rectangular" width="100%" height={40} />
        <MuiSkeleton variant="rectangular" width={200} height={40} />
      </Stack>
      <Stack direction="row" gap={1}>
        <MuiSkeleton variant="rectangular" width={40} height={40} />
        <MuiSkeleton variant="rectangular" width="100%" height={40} />
        <MuiSkeleton variant="rectangular" width={200} height={40} />
      </Stack>
    </Stack>
  );
};

export default Skeleton;
